import React from 'react';
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton, EmailShareButton } from 'react-share';
import { Button } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { useGetLineItems, useGetCustomerInfoData } from 'src/hooks';


export function ShareButtons(): React.ReactElement {
  const lineItems = useGetLineItems()
  const product = lineItems[0].product_data
  const title = product.product_title
  const customer = useGetCustomerInfoData()
  const linkToShare = `https://buynow-dot-bold-sales-demos.uc.r.appspot.com/channel/initialize?sku=${product.sku}&quantity=1&discount_code=SAVE10`
  const facebookShareLink = `https://www.facebook.com/sharer/sharer.php?u=${linkToShare}`
  const twitterShareLink = `https://twitter.com/intent/tweet?url=${linkToShare}&text=${title}`
  const emailShareLink = `mailto:${customer.email_address}?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(`Check out this link: ${linkToShare}`)}`
  const handleShareClick = (url) => {
    window.open(url, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400");
  };
    return (
      <div style={{display: 'flex', gap: '8px'}}>
        <Button variant="contained" style={{flex: 1, backgroundColor: '#000000'}} startIcon={<EmailIcon />} onClick={() => handleShareClick(emailShareLink)}>
          <EmailShareButton url={emailShareLink} subject={title} body={`Save 10% on ${title}: ${linkToShare}`}>
            Email
          </EmailShareButton>
        </Button>
        <Button variant="contained" style={{flex: 1, backgroundColor: '#000000'}} startIcon={<FacebookIcon />} onClick={() => handleShareClick(facebookShareLink)}>
          <FacebookShareButton url={facebookShareLink} quote={`Save 10% on ${title}`}>
            Facebook
          </FacebookShareButton>
        </Button>
        <Button variant="contained" style={{flex: 1, backgroundColor: '#000000'}} startIcon={<TwitterIcon />} onClick={() => handleShareClick(twitterShareLink)}>
          <TwitterShareButton url={twitterShareLink} title={`Save 10% on ${title}`}>
            Twitter
          </TwitterShareButton>
        </Button>
      </div>
    );
};
